import * as i0 from '@angular/core';
import { NgModule, InjectionToken, Inject, Injectable } from '@angular/core';

class LinksModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: LinksModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: LinksModule }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: LinksModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: LinksModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [],
                    exports: []
                }]
        }] });

const LINK_SERVICE = new InjectionToken('LinkService');

class LinkService {
    constructor(linkService) {
        this.linkService = linkService;
    }
    getAcceptedFileTypesLink() {
        return this.linkService.getAcceptedFileTypesLink();
    }
    getPrivacyPolicyLink() {
        return this.linkService.getPrivacyPolicyLink();
    }
    getTermsOfServiceLink() {
        return this.linkService.getTermsOfServiceLink();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: LinkService, deps: [{ token: LINK_SERVICE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: LinkService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: LinkService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LINK_SERVICE]
                }] }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LINK_SERVICE, LinkService, LinksModule };
